import { AlertMessage } from "components/Alert";
import { AppNavbar } from "components/AppBar";
import React from "react";
import { Outlet } from "react-router-dom";
import WrapperLayout from "../wrapper_layout";

export function PageLayout(props: any) {
  return (
    <WrapperLayout>
      <AppNavbar />
      <Outlet />
      <AlertMessage />
    </WrapperLayout>
  );
}

export default React.memo(PageLayout);
